import { motion } from 'framer-motion';

const Diamond = ({ delay, size, x, y }: { delay: number; size: number; x: number; y: number }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{
        opacity: [0.2, 0.4, 0.2],
        scale: [1, 1.1, 1],
        y: [y, y - 20, y],
      }}
      transition={{
        duration: 4,
        delay,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      className="absolute"
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        className="text-gold/20"
      >
        <path d="M12 2L2 12L12 22L22 12L12 2Z" />
      </svg>
    </motion.div>
  );
};

const Sparkle = ({ delay, size, x, y }: { delay: number; size: number; x: number; y: number }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0 }}
      animate={{
        opacity: [0, 0.5, 0],
        scale: [0, 1, 0],
        rotate: [0, 180, 360],
      }}
      transition={{
        duration: 2,
        delay,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      className="absolute"
      style={{
        left: `${x}%`,
        top: `${y}%`,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        className="text-gold/30"
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    </motion.div>
  );
};

export const AnimatedBackground = () => {
  const diamonds = [
    { delay: 0, size: 16, x: 10, y: 20 },
    { delay: 0.5, size: 24, x: 80, y: 40 },
    { delay: 1, size: 20, x: 30, y: 60 },
    { delay: 1.5, size: 16, x: 70, y: 80 },
    { delay: 2, size: 24, x: 20, y: 30 },
    { delay: 2.5, size: 20, x: 60, y: 50 },
  ];

  const sparkles = [
    { delay: 0.2, size: 12, x: 15, y: 25 },
    { delay: 0.7, size: 16, x: 85, y: 45 },
    { delay: 1.2, size: 14, x: 35, y: 65 },
    { delay: 1.7, size: 12, x: 75, y: 85 },
    { delay: 2.2, size: 16, x: 25, y: 35 },
    { delay: 2.7, size: 14, x: 65, y: 55 },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {diamonds.map((diamond, index) => (
        <Diamond key={`diamond-${index}`} {...diamond} />
      ))}
      {sparkles.map((sparkle, index) => (
        <Sparkle key={`sparkle-${index}`} {...sparkle} />
      ))}
    </div>
  );
}; 